import { objComparatorNumber } from "../utils.js";
import axios from 'axios';
import { endpoint, remoteCreate, remoteDelete, remoteModifyPut } from "./utils.js";
import { ipsumDevicesRootURL } from "./ipsum.js";

export function parkIpsumConfigRootURL() {
  return endpoint("internal/current/parkipsumconfs/");
}

export async function fetchParkIpsumConf(parkId) {
  try {
    const res = await axios.get(`${parkIpsumConfigRootURL()}${parkId}/`, {
      withCredentials: true
    });
    return res.data;
  } catch (e) {
    if (e.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (e.response.status === 404) {
        return null;
      } else {
        throw e;
      }
    } else if (e.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser
      throw e;
    } else {
      // Something happened in setting up the request that triggered an Error
      throw e;
    }
  }
}

export async function createParkIpsumConfig(useAlerts, payload) {
  await remoteCreate(
    useAlerts,
    parkIpsumConfigRootURL(),
    payload,
    'Park Ipsum Configuration',
    'ParkIpsumConfig',
    'park'
  );
}

export async function modifyPutParkIpsumConfig(useAlerts, payload, parkId) {
  await remoteModifyPut(
    useAlerts,
    `${parkIpsumConfigRootURL()}${parkId}/`,
    payload,
    'Park Ipsum Configuration',
    'ParkIpsumConfig',
    'park'
  );
}

export async function deleteParkIpsumConfig(useAlerts, parkId) {
  await remoteDelete(
    useAlerts,
    `${parkIpsumConfigRootURL()}${parkId}/`,
    'Park Ipsum Configuration',
    'ParkIpsumConfig',
  );
}
